<template>
  <flex-column class="ux-code-editor" v-if="mounted">
    <template v-if="tokens.length">
      <div class="tokens">
        <div class="tokens-header" @click="showTokens = !showTokens">
          <flex-row gap center>
            <flex-cell> {{ showTokens ? "Hide" : "Show" }} Tokens </flex-cell>
            <flex-cell shrink>
              <ux-icon :icon="showTokens ? 'fa-angle-up' : 'fa-angle-right'" />
            </flex-cell>
          </flex-row>
        </div>
        <div class="tokens-body" v-if="showTokens">
          <ux-button
            size="xs"
            v-for="token in tokens"
            @click.stop.prevent="injectToken(token.value)"
          >
            <ux-icon icon="fa-asterisk" /> {{ token.title }}</ux-button
          >
        </div>
      </div>
    </template>
    <qik-code-editor
      ref="editor"
      :syntax="lang"
      @blur="blurred"
      @focus="focussed"
      :readonly="readonly"
      :singleLine="singleLine"
      class="editor-wrap"
      v-model="model"
      style="height: 300px"
    />
  </flex-column>
</template>
<script>
import _debounce from "lodash/debounce";
// import { VAceEditor } from 'vue3-ace-editor';

export default {
  components: {
    // VAceEditor,
  },
  methods: {
    injectToken(value) {
      const editorInstance = this.$refs.editor;
      if (!editorInstance) {
        return;
      }

      editorInstance.inject(value);
    },

    // editorInit(editor) {
    //   this.editor = editor;
    // },
    focussed() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
    },
    blurred() {
      const self = this;
      self.timer = setTimeout(function () {
        self.format();
      }, 100);
    },
    format() {
      if (typeof window === undefined) {
        return;
      }

      var code = this.model;

      if (!code) {
        return;
      }

      switch (this.lang) {
        case "js":
        case "javascript":
          if (window.js_beautify) {
            code = window.js_beautify(code);
          }
          break;
        case "json":
          try {
            // Parse the JSON string
            const jsonObject = JSON.parse(code);

            // Format the JSON object with a 4-space indent
            const formattedJSON = JSON.stringify(jsonObject, null, 4);

            code = formattedJSON;
          } catch (error) {
            // Handle any errors that occur during parsing
            console.error("Unable to format invalid JSON string:", error);
          }

          break;
        case "css":
        case "scss":
          if (window.css_beautify) {
            code = window.css_beautify(code);
          }
          break;
        case "html":
          if (window.html_beautify) {
            code = window.html_beautify(code);
          }
          break;
        default:
          return;
          break;
      }

      // const {row, column} = this.editor.getCursorPosition();
      this.model = code;
      // this.editor.moveCursorTo(row, column)
    },
  },
  props: {
    modelValue: {
      type: String,
      default() {
        return "";
      },
    },
    tokens: {
      type: Array,
      default() {
        return [];
      },
    },
    lang: {
      type: String,
    },
    readonly: {
      type: Boolean,
    },
    singleLine: {
      type: Boolean,
    },
  },
  watch: {
    modelValue(v) {
      this.model = v;
    },
    model(v) {
      this.$emit("update:modelValue", v);
    },
    async formatReady() {
      if (!this.mounted) {
        return;
      }

      if (!this.$sdk.global || !this.$sdk.global.injectScript) {
        return;
      }

      switch (this.lang) {
        case "js":
        case "javascript":
          await this.$sdk.global.injectScript(
            "https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.5/beautify.min.js",
          );
          break;
        // case "json":
        //   await this.$sdk.global.injectScript(
        //     "https://cdnjs.cloudflare.com/ajax/libs/json-formatter/0.7.0/json-formatter.min.js",
        //   );
        //   json_beautify =
        //   break;
        case "css":
        case "scss":
          await this.$sdk.global.injectScript(
            "https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.5/beautify-css.min.js",
          );
          break;
        case "html":
          await this.$sdk.global.injectScript(
            "https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.5/beautify-html.min.js",
          );
          break;
      }
    },
  },
  unmounted() {
    this.editor = null;
  },
  mounted() {
    this.mounted = true;
  },
  computed: {
    formatReady() {
      return `${this.mounted}-${this.lang}`;
    },
  },
  data() {
    return {
      showTokens: false,
      timer: null,
      mounted: false,
      model: this.modelValue,
      editor: null,
      selectionContext: {},
    };
  },
};
</script>
<style lang="scss" scoped>
.editor-wrap {
  flex: 1;
}

.tokens-header {
  cursor: pointer;
  padding: 0.5em 1em;
  background: rgba(#000, 0.05);

  &:hover {
    background: rgba(#000, 0.1);
  }
}
.tokens-body {
  padding: 1em;

  .ux-btn {
    margin-bottom: 0.4em;
  }
}
</style>
